<template>
    <div class="tooltip relative inline-block">
        <div class="tooltip-element relative">
            <slot>
                <Icon name="tooltip" :height="4" :width="4"/>
            </slot>
            <div class="absolute w-full h-full top-0 left-0" @mouseover="onHover" @mouseout="show = false">
                <div class="tooltip-arrow w-full absolute -top-2 left-0 fade-in pointer-events-none" v-if="show"></div>
            </div>
        </div>
        <div v-if="show" class="tooltip-message-container absolute z-50 h-0 w-0 pointer-events-none" :class="[positionClassContainer]" :style="'z-index: 99999; width: ' + width + 'px'">
            <div class="tooltip-message shadow text-xs font-normal fade-in transform bg-neutral-default text-white p-4 absolute bottom-0 mb-4" :class="[positionClass,'tooltip-message-'+positionX]">
                <slot name="message"></slot>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: false,
            clientX: 0,
            clientY: 0,
        };
    },
    props: {
        width: {
            type: [Number,String],
            required: false,
            default: 300
        },
        positionX: {
            type: String,
            required: false,
            default: 'center'
        },
    },
    computed: {
        positionClass(){

            let positionClass = ''

            switch (this.positionX) {
                case 'center':
                    positionClass = '-translate-x-1/2'
                    break;
                case 'right':
                    positionClass = '-right-1--'
                    break;
            }

            return positionClass;
        },
        positionClassContainer(){

            let positionClass = ''

            switch (this.positionX) {
                case 'center':
                    positionClass = 'top-1/2 left-1/2'
                    break;
                case 'right':
                    positionClass = 'top-1/2 right-0'
                    break;
            }

            return positionClass;
        }
    },
    methods: {
        onHover(e) {
            const { clientX, clientY } = e;
            this.show = true;
            this.clientX = clientX;
            this.clientY = clientY;
        },
    },
};
</script>

<style scoped>
.tooltip-arrow::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #576874 transparent transparent transparent;
}
.tooltip-message.tooltip-message-center::after{

}

.tooltip-message.tooltip-message-right::after{
    left: 100%;
    margin-right: 5px;
}
.tooltip-message.tooltip-message-left::after{
    left: 0;
    margin-left: 5px;
}
</style>
